import { render } from "./video-sidebar.vue?vue&type=template&id=944d2a0e"
import script from "./video-sidebar.vue?vue&type=script&lang=js"
export * from "./video-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__